/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/

import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({
  organizationId: ZodTypes.Id,
  projectId: ZodTypes.Id,
  clusterId: ZodTypes.Id,
});

export const GetClusterOldestContinuousBackup = {
  id: 'cluster-continuous-backup-oldest.get',
  tag: 'Cluster',
  summary: 'Get cluster oldest continuous backup',
  description: 'Retrieve all cluster oldest continuous backups',
  method: 'get',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) =>
    `/organization/${params.organizationId}/project/${params.projectId}/cluster/${params.clusterId}/backup/continuous/oldest`,
  request: {
    params: Params,
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.strictObject({
            name: z.string(),
            lastModified: z.date(),
            sizeInBytes: z.number(),
          }),
        },
      },
    },
  },
} as const satisfies Endpoint;
